<template>

	<div id="layout-content" class="pt-4">
		<div v-if="enrollment.id" class="container">

			<h2>{{ $t('courses.welcome_to', { program_name: enrollment.program.display_name }) }}</h2>

			<div class="row" v-if="surveys.length > 0">
				<p class="w-100 p-0 px-3 m-0">{{ $t('courses.surveys_text') }}</p>
				<div v-for="survey in surveys" :key="survey.id" class="col-md-3">
					<div class="card stage survey bg-warning pointer" @click="surveyClick(survey.id)">
						<div class="card-body z100 text-center p-3">
							<h2>{{ $t('courses.survey_due')}}</h2>
							<h2 class="font-weight-bold m-0" v-if="survey.display_title != null">{{ survey.display_title }}</h2>
							<h2 class="font-weight-bold m-0" v-else>{{ survey.title() }}</h2>
						</div>
					</div>
				</div>
			</div>


			<ClipLoader v-if="!stagesLoaded" color="#5FB0E2" size="150px" class="p-5"></ClipLoader>
			<div class="row mb-4">
				<div v-for="stage in stages" :key="stage.id" class="col-md-3" v-if="Object.keys(stage.tasks).length > 0">
					<div v-if="stage.unlocked && !surveyDue && Object.keys(stage.tasks).length > 0" class="card stage position-relative z100 pointer bg999" @click="stageClick(stage.id)">
						<div class="card-body z100 text-center text-white p-2">
							<h2 class="text-white">{{stage.name}}</h2>
							<h1 class="text-white m-0">{{percentage(stage.completion)}}%</h1>
							<span>{{ $t('courses.stage_complete')}}</span>
						</div>
						<div class="progress otu-blue-bg w-100" :style="perCompleted(stage.completion)"></div>
					</div>
					<div v-if="(!stage.unlocked || surveyDue) && Object.keys(stage.tasks).length > 0" class="card stage position-relative z100">
						<div class="card-body z100 text-center text-white p-2">
							<h2 class="text-white">{{stage.name}}</h2>
							<h1 class="text-white m-0"><font-awesome-icon class="mr-2" :icon="['fas', 'lock']" /></h1>
							<span>{{ expectedStart(stage) }}</span>
						</div>
					</div>
				</div>
			</div>


			<div class="m-1 my-3" v-if="Object.keys(measures).length > 0">
				<h2 @click="showMeasures = !showMeasures" class="pointer">
					{{ $t('courses.measures_title') }}
					<font-awesome-icon v-if="!showMeasures" :icon="['fas', 'caret-down']" />
					<font-awesome-icon v-if="showMeasures" :icon="['fas', 'caret-up']" />
				</h2>
				<div class="w-100"></div>
				<div v-if="showMeasures">
					<div v-for="measure in measures" :key="measure.id" class="">
						<h3 class="m-0 p-0">{{ measure.title }}</h3>
						<LineChart :chartdata="formatData(measure)" :options="measure.options" />
					</div>
				</div>
			</div>
			
			<div id="jumpToAdditionalResource"></div>
			<div class="m-1 mb-4" v-if="enrollment.program && Object.keys(resources).length > 0 && !surveyDue">
				<h2 @click="showAdditional = !showAdditional" class="pointer mb-1">
					{{ $t('courses.additional_resources') }}
					<font-awesome-icon v-if="!showAdditional" :icon="['fas', 'caret-down']" />
					<font-awesome-icon v-if="showAdditional" :icon="['fas', 'caret-up']" />
				</h2>
				<div v-if="showAdditional">{{ $t('courses.additional_resources_instruction') }}</div>
				<b-tabs card v-if="showAdditional">
					<b-tab v-for="additionalResourceCategory in additionalResourceCategories" v-if="allAdditionalResourceCategoryIds.includes(parseInt(additionalResourceCategory['id']))" :title="additionalResourceCategory['name']">
							<div v-if="showAdditional" class="row">
							<!-- <div v-for="additionalResourceKey in additionalResourcesOrder" :key="additionalResourceKey" class="col-md-12 mx-1"> -->
							<!-- <a :href="resources[additionalResourceKey].resource.url" @click="additionalResourceClicked(resources[additionalResourceKey].id)" target='_blank'><font-awesome-icon :icon="['far', 'file-pdf']" /> {{resources[additionalResourceKey].description}}</a> -->
								<div v-if="resources[additionalResourceKey].additional_resource_category_id == additionalResourceCategory['id']" v-for="additionalResourceKey in additionalResourcesOrder" :key="additionalResourceKey" class="card mr-3 mb-3 mt-3" style="width: 10rem;">
									<a v-if="resources[additionalResourceKey].additional_resource_category_id == additionalResourceCategory['id']" :href="resources[additionalResourceKey].resource.url" @click="additionalResourceClicked(resources[additionalResourceKey].id)" target='_blank' class="text-center" oncontextmenu="return false;">
										<div v-if="flaggedIds.includes(parseInt(resources[additionalResourceKey].id))" class="card-header text-white pl-1 pt-1 pb-1 pr-0" v-bind:style="{ backgroundColor: '#5594c3' }" v-b-tooltip :title="$t('courses.additional_resources_recommended_message')">
										<i class="fa fa-star mr-2" aria-hidden="true"></i>{{ $t('courses.additional_resources_recommended')}}</div>
										<div v-else class="card-header text-white pl-1 pt-1 pb-1 pr-0" v-bind:style="{ backgroundColor: 'white', border: 0 }">.</div>
										<div class="card-body pb-0 pl-0 pr-0" v-b-tooltip.hover.bottom :title="getAdditionalResourceToottip(resources[additionalResourceKey].last_downloaded_at)">
											<font-awesome-icon :icon="['far', 'file-pdf']" size="2x" :style="{ color: '#5594c3' }" v-if="resources[additionalResourceKey].view_count > 0" />
											<font-awesome-icon :icon="['fas', 'file-pdf']" size="2x" :style="{ color: '#5594c3' }" v-else />
											<div><span class="m-0 text-dark">{{resources[additionalResourceKey].description}}</span></div>
											<!-- <p v-if="flaggedIds.includes(parseInt(resources[additionalResourceKey].id))">this is flagged</p> -->
											<!-- <p class="w-100 m-0 text-dark">{{resources[additionalResourceKey].id}}</p> -->
										</div>
									</a>
								</div>			
							</div>
					</b-tab>
				</b-tabs>
				
				
			</div>

			<div v-if=" user.shared_file || (files.length > 0)">			
				<div class="card-body bg-white border">
                    <div class="card-header bg-transparent p-0 mb-3">
                        <h1><i class="fa fa-folder-open-o"></i>  {{ $t('courses.shared_files_header') }}
                            <div class="btn-group float-right">
                                <button type="button" v-if="user.shared_file" class="btn btn-light btn-icon px-3" @click="newFile()" v-b-tooltip :title="$t('courses.add_shared_file_title')"> 
                                    <i class="fa fa-plus fa-lg"></i>
                                </button>
                            </div>
                        </h1>
                    </div>

                    <div>
                        <!-- <table v-if="user.shared_file || (files.length > 0)" class="table table-striped table-hover"> -->
                            <table  v-if="files.length > 0" class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>{{$t('file_label')}}</th>
                                    <th>{{$t('size_label')}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="file in files" :key="file.id">
                                    <td><a :href="file.url" target="_blank">{{ file.filename }}</a></td>
                                    <td>{{ getReadableFileSize(file.filesize) }}</td>
									<td class="text-right">
                            			<button type="button" @click="hide(file.shared_file_id)" class="btn btn-light btn-icon px-2 mr-2" v-b-tooltip :title="$t('delete_button')">
                                		 <i class="fa fa-trash fa-lg"></i>
                            			</button>
									</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
				</div>

                
                    <b-modal id="modalFile" ref="modalFile" :title="$t('courses.add_shared_file_title')" size="xs" centered @ok="addFile()" :ok-title="$t('courses.withdraw_ok_button')" :cancel-title="$t('cancel_button')">
                    <div class="uniform-uploader border w-100">
                        <input type="file" name="file" accept="image/*,.pdf,.xlsx,.docx,.mp3,.mp4" @change="fileChange($event.target.files)" />
                        <!-- <span class="filename border-0 pl-1" style="user-select: none;" v-html="(clientFile.name) ? clientFile.name : 'Drop File here'"></span> -->
                        <!-- <span class="action btn btn-secondary" style="user-select: none;">Choose File</span> -->
                    </div>
                    </b-modal>

            </div>

			<div class="m-1 my-3" v-if="Object.keys(surveysCompleted).length > 0">
				<h2 @click="showCompletedSurveys = !showCompletedSurveys" class="pointer">
					{{ $t('courses.surveys_completed') }}
					<font-awesome-icon v-if="!showCompletedSurveys" :icon="['fas', 'caret-down']" />
					<font-awesome-icon v-if="showCompletedSurveys" :icon="['fas', 'caret-up']" />
				</h2>
				<div class="w-100"></div>
				<div v-if="showCompletedSurveys" class="row">
					<div v-for="survey in surveysCompleted" :key="survey.id" class="col-md-3">
						<!-- <router-link :to="{ name: 'therapy.survey_result', params: { enrol_id: enrol_id, survey_link_id: survey.id } }"> -->
							<div class="card stage survey bg-light" @click="showSurveyResultModal(survey.id)">
								<div class="card-body z100 text-center">
									<h3 class="m-0 p-0" v-if="survey.display_title != null">{{ survey.display_title }}</h3>
									<h3 class="m-0 p-0" v-else>{{ survey.title() }}</h3>
								</div>
							</div>
						<!-- </router-link> -->
					</div>
				</div>
			</div>

		</div>

		<div v-else class="container">

			<div class="alert alert-danger" role="alert">{{ $t('course.missing') }}</div>

		</div>

		<p class="text-center mt-3"><router-link :to="{ name: 'therapy' }" class="btn btnSubmit btn-secondary p-2" tag="button">{{ $t('courses.back') }}</router-link></p>
		
		<b-modal id="surveyResultModal" ref="surveyResultModal" title="Survey Result" size="xl" ok-only>
			<clip-loader v-if="!loaded" color="#2196F3" size="100px" class="p-5"></clip-loader>
			<SurveyComp :survey="surveyModel"></SurveyComp>
		</b-modal>
	</div>

</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers'

import moment from 'moment'

import * as SurveyVue from 'survey-vue'

var SurveyComp = SurveyVue.Survey;
SurveyComp.cssType = "bootstrap"
SurveyVue.JsonObject.metaData.addProperty('survey', {name: '_id:number', default: {} })
SurveyVue.JsonObject.metaData.addProperty('questionbase', {name: '_id:number', default: {} })

import Survey from '@/models/survey';

export default {
	name: 'TherapyDisplay',
	components: {
		LineChart: () => import ('@/components/graph/LineChart.vue'),
		ClipLoader: () => import ('vue-spinner/src/ClipLoader'),
		SurveyComp
	},
	data () {
    return {
			showAdditional: true,
      showCompletedSurveys: false,
			showMeasures: false,
			surveyModel: new SurveyVue.Model(),
			loaded: false,
			clientFile: {},
			allAdditionalResourceCategoryIds: [],
			allowedFileTypes: ['image/jpeg', 'image/png', 'image/gif', 'text/plain', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'video/mp4', 'audio/mpeg']
    }
  },
	created () {
		this.fetchResources(this.enrol_id).then((res) => {
			this.allAdditionalResourceCategoryIds = Object.values(this.resources).map((res) => res.additional_resource_category_id);
		});
		this.fetchFlaggedResources(this.enrol_id);
		this.fetchSharedFiles(this.enrol_id);
		this.fetchAdditionalResourceCategories();
	},
	mounted() {
		if(this.$route.query && this.$route.query.actionjump && this.$route.query.actionjump=='yes') {
			const element = document.getElementById('jumpToAdditionalResource');
			if(element) {
				element.scrollIntoView(true);
			}
		}	
	},
	computed: {
		enrol_id () {
			return this.$route.params.enrol_id;
		},
		enrollment () {
			return this.$store.state.programs.enrollment;
		},
		user () {
            return this.$store.state.auth.user;
        },
		surveys () {
			return (this.$store.state.surveys.surveys) ? _.orderBy(this.$store.state.surveys.surveys, 'position', 'asc') : {};
		},
		surveyDue () {
			return (Object.keys(this.surveys).length > 0) ? true : false;
		},
		surveysCompleted () {
			return (this.$store.state.surveys.completed) ? this.$store.state.surveys.completed : {};
		},
		measures () {
			if (this.$store.state.programs.graphs) {
				let graphs = this.$store.state.programs.graphs;
				let keys = Object.keys(graphs);
        let ref = this;
        keys.forEach(function(key) {
        	// Adds space to the top of the Graph
           let annotations_val =  ref.formatGraphThreshold(graphs[key].graph_thresholds);
					 let maxY = graphs[key].max_y;

					graphs[key].options = { responsive: true, maintainAspectRatio: false, legend: { display: true },
						scales: { xAxes: [{ ticks: { autoSkip: false } }], yAxes: [{ ticks: { max: maxY, min: 0 } }] },
             annotation: {
                 annotations : annotations_val
             }
					}
				});
				return this.$store.state.programs.graphs;
			}
			return {};
		},
		stages () {
			return _.orderBy(this.$store.state.programs.stages, 'position', 'asc');
		},
		stagesLoaded () {
			return Object.keys(this.stages).length > 0;
		},
		resources () {
			return (this.$store.state.programs.resources) ? this.$store.state.programs.resources : {};
		},
		flaggedIds () {
			return (this.$store.state.programs.flagged_ids) ? this.$store.state.programs.flagged_ids : [];
		},
		additionalResourcesOrder: {
			get: function() {
				let sortedKeys = Object.entries(this.resources).sort( (a,b) => { return a[1].position - b[1].position; }).map(a => a[0]);
				return sortedKeys;
			}
		},
		files () {
            let files = this.$store.state.users.shared_files;
            return _.orderBy(files, 'filename', 'desc');
        },
		additionalResourceCategories () {
            return (this.$store.state.programs.additional_resource_categories) ? _.orderBy(this.$store.state.programs.additional_resource_categories, 'name') : {};
        },
		surveyJSdata () {
			return this.current_survey.toSurveyJS(true, ((this.currentSurveyLink) ? this.currentSurveyLink['display_title'] : null));
		},
		resultJSdata () {
			return this.survey_result.resultJSdata();
		},
        survey_result () {
			return this.$store.state.surveys.survey_result;
		},
        currentSurveyLink () {
			return this.survey_result.survey_link;
		},
        current_survey () {
			return this.survey_result.survey;
		}
	},
	methods: {
		...mapActions(['fetchResources','additionalResourceView', 'fetchFlaggedResources', 'fetchSharedFiles', 'addSharedFile', 'hideSharedFile', 'fetchAdditionalResourceCategories', 'fetchSurveyResult']),
		perCompleted (per) {
			return 'height: '+(per * 100)+'%';
		},
		percentage (per) {
			return Math.floor(Number.parseFloat((per * 100)));
		},
		additionalResourceClicked (id){
			this.additionalResourceView({enrol_id: this.enrol_id, resource_id: id});
			this.fetchResources(this.enrol_id);
		},
		getAdditionalResourceToottip(last_downloaded_at){
			if (last_downloaded_at !=null) {
				let temp = moment(String(last_downloaded_at)).format('M/D/YY')
				return this.$t('courses.additional_resources_last_accessed') + temp;
			}else {
				return this.$t('courses.additional_resources_never_accessed');
			}
			
		},
		stageClick (id) {
			this.$router.push({ name: 'therapy.stage', params: { enrol_id: this.enrol_id, stage_id: id } });
		},
		surveyClick (id) {
			this.$router.push({ name: 'therapy.survey', params: { enrol_id: this.enrol_id, survey_id: id } });
		},
		formatData (measure) {
            let points = measure.data_points;
            let labels = [];
            let data = [];
            let keys = Object.keys(points);
            if (keys.length == 0) return {};
            keys.forEach( function (key) {
              if(points[key].xLabel){
                   labels.push(points[key].xLabel);
              }else{
                  labels.push(points[key].pointName);
              }
                data.push(points[key].score);
            });
            return {labels: labels, datasets: [{label: (measure.legend) ? measure.legend: measure.title, data: data, borderColor: measure.colour, pointBackgroundColor: '#247B7B', pointRadius:4 }] };
        },
		formatGraphThreshold (graph_thresholds) {
			let graph_threshold_array = [];
				graph_thresholds.forEach(graph_threshold => {
					graph_threshold_array.push(
						{   type: 'line',
							mode: 'horizontal',
							scaleID: 'y-axis-0',
							value: graph_threshold.value,
							borderColor: graph_threshold.colour,
							borderWidth: 1,
							label: {
									backgroundColor: 'white',
									fontSize: 10,
									fontColor: "black",
									position: "right",
									content: graph_threshold.title,
									enabled: true
									}
						});
				});

			return graph_threshold_array;
		},
		expectedStart (stage) {
            let task_keys = Object.keys(stage.tasks);
			task_keys.forEach( function (taskKey) {
				if (stage.tasks[taskKey].position == 0){
					task_keys[0] = taskKey;
				}
			});
            let locks = stage.tasks[task_keys[0]].locks;
            let lock_keys = Object.keys(locks);
            let lock_task = locks[lock_keys[0]];

            return (lock_task && lock_task.item_type == 'delay') ? moment(this.enrollment.starts_at).add(lock_task.expires_in, 'minutes').format('MMMM D, YYYY') : ((this.surveyDue)?this.$t('courses.survey_due'):this.$t('courses.survey_no_delay'));

        },
		newFile () {
            this.$refs.modalFile.show();
		},
         addFile () {
            let formData = new FormData();
            // Check for Allowed File Types
            if (!this.allowedFileTypes.includes(this.clientFile.type)) {
				this.$swal({title: this.$t('courses.add_shared_file_failed'), type: 'error'});
                this.clientFile = {};
                return;
            }
          	formData.append('file', this.clientFile, this.clientFile.name);
			this.addSharedFile({formData: formData, enrollment_id: this.enrol_id}).then((v) => {
				this.$swal({title: this.$t('courses.add_shared_file_success'), type: 'success'});
				// this.$swal({title: this.$t('courses.survey_complete'), type: 'success'});
				this.clientFile = {};
			}).catch(errHandler);
        },
        fileChange (files) {
            this.clientFile = files[0];
        },
		hide ( shared_file_id ) {
            this.$swal({
				title: this.$t('delete_button'),
				// title: 'Delete file',
				type: 'warning',
				showCancelButton: true,
                cancelButtonText: this.$t('cancel_button'),
                confirmButtonText: this.$t('courses.withdraw_ok_button'),
                confirmButtonColor: '#C82232'
			}).then((result) => {
                if (result.value == true) {
                    this.hideSharedFile({ shared_file_id: shared_file_id, enrollment_id: this.enrol_id});
                }
			});
        },
		getReadableFileSize(bytes){
            if (bytes < 1024) {
            return bytes + " B";
        } 
        else if (bytes < 1024 * 1024) {
            return (bytes / 1024).toFixed(2) + " KB";
        } 
        else if (bytes < 1024 * 1024 * 1024) {
            return (bytes / (1024 * 1024)).toFixed(2) + " MB";
        } 
        else {
            return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
          }
		},
		showSurveyResultModal(survey_link_id) {
			this.surveyModel = new SurveyVue.Model(); // for resetting the data
			this.$refs.surveyResultModal.show();
			this.loaded = false;
			this.fetchSurveyResult({enrol_id: this.enrol_id, surveylink_id: survey_link_id}).then((v) => {
			this.surveyModel = new SurveyVue.Model(this.surveyJSdata);
			this.surveyModel.data = this.resultJSdata;
			this.surveyModel.mode = 'display';

			this.surveyModel.css = {
				header: "panel-heading card-header p-0 pt-2 pl-2 pb-1 border-bottom",
				body: "panel-body card-block"
			};

			// Replace text input box with DIV to fix overflow and add line wrapping
			$('.sv_main').ready(function(){
				$('.sv_main input[type=text]').each(function(index, ele){
					$(ele).after('<div class="border-bottom">'+$(ele).val()+'</div>').hide();
				});
			});
			this.loaded = true;
			});

		}
	}
}
</script>


<style>
.z100 {
	z-index: 100;
}
.card.stage.bg999 {
	background: #999;
}
.card.stage {
	background: #CCC;
	margin-bottom: 1.5em;
}
.card.stage h1 {
	font-size: 4em;
	font-weight: 1000;
}
.progress {
	position: absolute;
	bottom: 0px;
	left: 0px;
	width: 100%;
	z-index: 5;
	height: 90%;
	opacity: 0.9;
}

/* Indent Radio Inputs */
.sv_qcbc .radio label:last-child {
	display: inline-block;
	padding-left: 30px;
	margin-bottom: 5px;
}
.sv_qcbc .radio label:last-child input {
	margin-left: -20px;
}

label.btn-secondary.active {
	background-color: #2196F3;
}
</style>
